module.exports = __webpack_public_path__ + "static/media/logo-mei.45927a35.png";